export default {
  getIsAuthenticated(state) {
    return state.authenticated;
  },
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/authentication.getters.js